import { configureStore } from '@reduxjs/toolkit';
import appConfigReducer from './appConfigReducer';
import filtersReducer from './filtersReducer';
import locationReducer from './locationReducer';
import vehicleListReducer from './vehicleListReducer';
import { IS_TESTING_ENVIRONMENT } from '../constants/environment';
import sortByReducer from './sortByReducer';
import vendorCTAsReducer from './vendorCTAsReducer';
import priceBreakdownsReducer from './priceBreakdownReducer';
import vehicleListOneGraphReducer from './vehiclesReducer';

export const store = configureStore({
  reducer: {
    vehicles: vehicleListReducer,
    location: locationReducer,
    filters: filtersReducer,
    config: appConfigReducer,
    sortBy: sortByReducer,
    vendorCtaGroup: vendorCTAsReducer,
    priceBreakdownGroup: priceBreakdownsReducer,
    vehiclesOneGraph: vehicleListOneGraphReducer,
  },
  devTools: IS_TESTING_ENVIRONMENT,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
